import React from 'react'
import '../css/PrivacyPolicy.css'

function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <div className="privacy-wrapper">
        <header className="privacy-header">
          <h1 className="privacy-title">Privacy Policy</h1>
          <p className="privacy-effective-date">Effective Date: 08th Sep'25</p>
        </header>

        <div className="privacy-content">
          <div className="privacy-intro">
            <p className="privacy-intro-text">
              Manthan IT Solutions ("we", "our", "us") respects your privacy and is committed to protecting the
              personal data you share with us when using our website, mobile applications, or WhatsApp
              Business API services. This Privacy Policy explains how we collect, use, share, and safeguard
              your information.
            </p>
          </div>

          <section className="privacy-section">
            <h2 className="privacy-section-title">1. Information We Collect</h2>
            <ul className="privacy-list">
              <li className="privacy-list-item">
                <strong className="privacy-list-label">Business Information:</strong> 
                Organization name, contact details, KYC documents, and registration data.
              </li>
              <li className="privacy-list-item">
                <strong className="privacy-list-label">Communication Data:</strong> 
                WhatsApp messages, chat logs, reports, and analytics generated while using our services.
              </li>
              <li className="privacy-list-item">
                <strong className="privacy-list-label">Technical Data:</strong> 
                Device details, IP address, operating system, and usage analytics.
              </li>
              <li className="privacy-list-item">
                <strong className="privacy-list-label">Payment Information:</strong> 
                Wallet balance, invoices, and transaction details (we do not store sensitive card data).
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">2. How We Use Your Information</h2>
            <p className="privacy-section-intro">We use your information to:</p>
            <ul className="privacy-list">
              <li className="privacy-list-item">Provide and manage WhatsApp Business API services.</li>
              <li className="privacy-list-item">Enable account setup, verification, and onboarding.</li>
              <li className="privacy-list-item">Ensure compliance with WhatsApp (Meta) policies.</li>
              <li className="privacy-list-item">Deliver analytics and reporting tools.</li>
              <li className="privacy-list-item">Process billing, payments, and refunds.</li>
              <li className="privacy-list-item">Provide technical support and updates.</li>
              <li className="privacy-list-item">Improve the functionality, security, and reliability of our services.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">3. Data Retention</h2>
            <ul className="privacy-list">
              <li className="privacy-list-item">
                Chat logs, reports, and other service-related data are retained as per the applicable
                Statement of Work (SOW) or Non-Disclosure Agreement (NDA). Unless otherwise
                specified, chat logs and reports are typically retained for 90 days, after which they are
                securely deleted.
              </li>
              <li className="privacy-list-item">
                Upon termination of services, customer data will be deleted within 30 days, unless a
                different retention period is specified in the SOW, NDA, or required by law.
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">4. Data Security</h2>
            <p className="privacy-section-intro">
              We implement appropriate organizational and technical measures to protect your information, including:
            </p>
            <ul className="privacy-list">
              <li className="privacy-list-item">Encryption (HTTPS/TLS) during transmission.</li>
              <li className="privacy-list-item">Restricted access to personal data.</li>
              <li className="privacy-list-item">Regular monitoring and audits.</li>
            </ul>
            <p className="privacy-disclaimer">
              While we take reasonable precautions, no method of electronic storage or transmission is 100% secure.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">5. Consent & Responsibilities</h2>
            <ul className="privacy-list">
              <li className="privacy-list-item">
                Customers using our services must obtain valid end-user consent before sending messages.
              </li>
              <li className="privacy-list-item">
                Users must comply with WhatsApp's Business Solution Terms, Business Policy, and Commerce Policy.
              </li>
              <li className="privacy-list-item">
                Policy violations may result in suspension of services.
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">6. Sharing of Information</h2>
            <p className="privacy-section-intro">
              We do not sell or rent your data. Information may only be shared with:
            </p>
            <ul className="privacy-list">
              <li className="privacy-list-item">
                <strong className="privacy-list-label">WhatsApp (Meta):</strong> For service delivery and compliance.
              </li>
              <li className="privacy-list-item">
                <strong className="privacy-list-label">Service Partners:</strong> For integrations, training, or lawful service delivery.
              </li>
              <li className="privacy-list-item">
                <strong className="privacy-list-label">Authorities:</strong> If required by law or to prevent fraud/misuse.
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">7. Payments & Refunds</h2>
            <ul className="privacy-list">
              <li className="privacy-list-item">
                Charges follow WhatsApp (Meta) pricing and usage.
              </li>
              <li className="privacy-list-item">
                Refunds, where applicable, are processed within 30 working days, subject to taxes and usage.
              </li>
              <li className="privacy-list-item">
                Usage-based charges are non-refundable except in cases of verified service failure.
              </li>
                <li className="privacy-list-item">
               Minimum auto pay deduction should be in between of INR 1000/- to 10000/- only.
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">8. Your Rights</h2>
            <p className="privacy-section-intro">You may have the right to:</p>
            <ul className="privacy-list">
              <li className="privacy-list-item">Access and review your personal data.</li>
              <li className="privacy-list-item">Request correction or deletion of your data.</li>
              <li className="privacy-list-item">Withdraw consent for communications.</li>
              <li className="privacy-list-item">File a complaint with a data protection authority.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">9. Children's Privacy</h2>
            <p className="privacy-section-text">
              Our services are intended for businesses. We do not knowingly collect information from
              individuals under 18.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">10. Governing Law</h2>
            <p className="privacy-section-text">
              This Privacy Policy is governed by the laws of India, with exclusive jurisdiction of courts in
              New Delhi, India.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">11. Updates</h2>
            <p className="privacy-section-text">
              We may update this Privacy Policy periodically. Updates will be posted here with the revised
              "Last Updated" date.
            </p>
          </section>

          <section className="privacy-section privacy-contact">
            <h2 className="privacy-section-title">12. Contact Us</h2>
            <p className="privacy-section-text">
              For questions, concerns, or requests regarding your personal data or this Privacy Policy, please
              contact us at:
            </p>
            <div className="privacy-contact-info">
              <p className="privacy-company-name">Manthan IT Solutions</p>
              <address className="privacy-address">
                Ground Floor, 27, Jangpura Extension,<br />
                Opp. Shahi Masjid Road, Bhogal,<br />
                New Delhi – 110014, India
              </address>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy